import moment from "moment";

const testStatus = {
  prepare: 1,
  start: 2,
  finish: 3,
  canseled: 4,
};

const solvingByNumber = {
  questionCount: 20,
  solvingTime: "20 миин.",
  allovedErrors: "2",
};
const solvingByTheme = {
  getquestionCount: (count, theme) => {
    return `Колл-во вопросов: ${count}. Тема: ${theme}`;
  },
  questionCount: "",
  solvingTime: null,
  allovedErrors: "0",
};
const solvingMarathon = {
  questionCount: 1000,
  solvingTime: null,
  allovedErrors: null,
};

const testType = {
  bilet: { type: 1, conditions: solvingByNumber },
  theme: { type: 2, conditions: solvingByTheme },
  marathon: { type: 3, conditions: solvingMarathon },
  preview: { type: 4, conditions: null },
  exam: { type: 5, conditions: solvingByNumber },
};

function formatTestDuration(startTime, endTime) {
  const diffSeconds = endTime - startTime;

  const duration = moment.duration(diffSeconds, "seconds");

  const hours = Math.floor(duration.asHours());
  const minutes = Math.floor(duration.asMinutes()) % 60;
  const seconds = Math.floor(duration.asSeconds()) % 60;

  const hh = String(hours).padStart(2, "0");
  const mm = String(minutes).padStart(2, "0");
  const ss = String(seconds).padStart(2, "0");

  let parts = [];

  if (hours > 0) parts.push(`${hh} ч`);
  if (minutes > 0 || hours > 0) parts.push(`${mm} мин`);
  parts.push(`${ss} с`);

  return parts.join(" : ");
}
export {
  testStatus,
  testType,
  solvingByNumber,
  solvingByTheme,
  solvingMarathon,
  formatTestDuration,
};
